module.exports = __webpack_public_path__ + "img/hrlogo.791fd15b.png";